var $bf3f89a84488b301$exports = {};
$bf3f89a84488b301$exports = {
    "loading": `L\xe4ser in...`,
    "placeholder": `V\xe4lj\u{2026}`
};


export {$bf3f89a84488b301$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
